<div class="container border rounded pt-4 pb-2">
	<div class="row text-center mb-2">
		<span class="theme-main-color fw-bold fs-4">
			Temps de travail par employé
		</span>
	</div>
	<div class="row">
		<div echarts [options]="workingTime"></div>
	</div>
	<div class="row my-3">
		<div echarts [options]="workingAndTravelTime"></div>
	</div>
</div>
